import { render, staticRenderFns } from "./QAgentAccountLedgerDataTable.vue?vue&type=template&id=99f4932a&scoped=true&"
import script from "./QAgentAccountLedgerDataTable.vue?vue&type=script&lang=js&"
export * from "./QAgentAccountLedgerDataTable.vue?vue&type=script&lang=js&"
import style0 from "./QAgentAccountLedgerDataTable.vue?vue&type=style&index=0&id=99f4932a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f4932a",
  null
  
)

export default component.exports